import CustomHelmet from "components/calculations/components/CustomHelmet";
import ClientDocumentSettingsForm from "components/clients/forms/ClientDocumentSettingsForm";
import Modal from "components/common/Modal";

const MODAL_NAME = "CLIENT_DOCUMENT_SETTINGS";

const ClientDocumentSettingsModal = () => {
  return (
    <Modal
      size="md"
      name={MODAL_NAME}
      form={MODAL_NAME}
      noHeader
      submitButtonTitle="Confirm"
      className="client-document-settings-form"
      showCloseButton
    >
      <CustomHelmet
        title="Settings"
        description="Settings"
        href="https://www.divorcepath.com/app/[new-document]"
        isCanonical
      />
      <ClientDocumentSettingsForm formId={MODAL_NAME} />
    </Modal>
  );
};

export default ClientDocumentSettingsModal;
